import { useState } from "react";
import { User, LogOut, Heart, Package, ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { AuthModal } from "@/components/auth/AuthModal";
import { useAuth } from "@/hooks/useAuth";
import { toast } from "sonner";

export const UserMenu = () => {
  const { user, isAuthenticated, signOut, isLoading } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState<"login" | "signup">("login");

  const handleSignOut = async () => {
    await signOut();
    toast.success("Déconnexion réussie");
  };

  const openLogin = () => {
    setAuthMode("login");
    setShowAuthModal(true);
  };

  const openSignup = () => {
    setAuthMode("signup");
    setShowAuthModal(true);
  };

  if (isLoading) {
    return (
      <Button variant="ghost" size="icon" disabled>
        <User className="h-5 w-5" />
      </Button>
    );
  }

  if (isAuthenticated) {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm" className="gap-2">
            <div className="h-7 w-7 rounded-full bg-primary/10 flex items-center justify-center">
              <User className="h-4 w-4 text-primary" />
            </div>
            <span className="hidden md:inline text-sm">
              {user?.user_metadata?.full_name?.split(" ")[0] || "Mon compte"}
            </span>
            <ChevronDown className="h-4 w-4 hidden md:block" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48">
          <DropdownMenuItem asChild>
            <Link to="/compte" className="flex items-center gap-2">
              <User className="h-4 w-4" />
              Mon compte
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link to="/compte?tab=orders" className="flex items-center gap-2">
              <Package className="h-4 w-4" />
              Mes commandes
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link to="/compte?tab=wishlist" className="flex items-center gap-2">
              <Heart className="h-4 w-4" />
              Mes favoris
            </Link>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={handleSignOut} className="text-destructive">
            <LogOut className="h-4 w-4 mr-2" />
            Déconnexion
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  return (
    <>
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="sm" onClick={openLogin} className="hidden md:flex">
          Connexion
        </Button>
        <Button size="sm" onClick={openSignup} className="hidden md:flex">
          S'inscrire
        </Button>
        <Button variant="ghost" size="icon" onClick={openLogin} className="md:hidden">
          <User className="h-5 w-5" />
        </Button>
      </div>

      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        defaultMode={authMode}
      />
    </>
  );
};
